module.exports = __webpack_public_path__ + "img/portrait-003.12cbeaa2.jpg";